module.exports = __webpack_public_path__ + "static/media/fix_cash100.2910abe2.png";